import 'antd/dist/antd.css';

import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';

import { SpecialFeatureUnlockProvider } from './contexts/SpecialFeatureUnlockContext';
import Routes from './routes';
import history from './services/history';
import { persistor, store } from './store';
import GlobalStyle from './styles/global';
import { defaultTheme } from './styles/themes/default';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={defaultTheme}>
        <PersistGate persistor={persistor}>
          <SpecialFeatureUnlockProvider>
            <Router history={history}>
              <Routes />
              <GlobalStyle />
              <ToastContainer autoClose={3000} />
            </Router>
          </SpecialFeatureUnlockProvider>
        </PersistGate>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
